var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.207 25.7578H7.79297C7.11342 25.7578 6.5625 26.3087 6.5625 26.9883V29.5312H35.4375V26.9883C35.4375 26.3087 34.8866 25.7578 34.207 25.7578Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 14.5195C28.875 13.84 28.3241 13.2891 27.6445 13.2891H22.2305V9.02344H29.2031C29.6295 9.02344 30.0256 8.80269 30.2498 8.43987C30.474 8.07713 30.4944 7.62415 30.3037 7.2427L28.9382 4.51172L30.3037 1.78073C30.4945 1.39937 30.4741 0.946312 30.2499 0.58357C30.0256 0.220746 29.6295 0 29.2031 0H21C20.3205 0 19.7695 0.550922 19.7695 1.23047V13.2891H14.3555C13.6759 13.2891 13.125 13.84 13.125 14.5195V17.0625H28.875V14.5195Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 20.7539V23.2969H32.1562V20.7539C32.1562 20.0744 31.6053 19.5234 30.9258 19.5234H11.0742C10.3947 19.5234 9.84375 20.0744 9.84375 20.7539Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4883 31.9922H4.51172C3.83217 31.9922 3.28125 32.5431 3.28125 33.2227V35.7656H38.7188V33.2227C38.7188 32.5431 38.1678 31.9922 37.4883 31.9922Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.457V40.7695C0 41.4491 0.550922 42 1.23047 42H40.7695C41.4491 42 42 41.4491 42 40.7695V39.457C42 38.7775 41.4491 38.2266 40.7695 38.2266H1.23047C0.550922 38.2266 0 38.7775 0 39.457Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.8f28fd895a37a1299a0f93d886e0b118.svg";
export { ForwardRef as ReactComponent };